import "@/styles/book.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SpaceProvider } from "@/context/SpaceContext";
import { AppShell } from "@/components/layout/AppShell";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import LibraryPage from "@/pages/LibraryPage";
import { AdminOnly } from "@/components/layout/AdminOnly";
import SearchPage from "@/pages/SearchPage";
import AlbumsPage from "@/pages/AlbumsPage";
import AlbumPage from "@/pages/AlbumPage";
import PublicAlbumPage from "@/pages/PublicAlbumPage";
import DuplicatesPage from "@/pages/DuplicatesPage";
import SettingsPage from "@/pages/SettingsPage";
import ImportPage from "@/pages/ImportPage";
import { TakeoutProvider } from "@/context/TakeoutContext";
import AdminPage from "@/pages/AdminPage";
import { GuestApp, GuestLanding } from "@/components/guest/GuestApp";
import { OfflineBanner } from "@/components/layout/OfflineBanner";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import { isGuest } from "@/lib/guest";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  if (location.pathname.startsWith("/g/")) return <Routes><Route path="/g/:token" element={<GuestLanding />} /></Routes>;
  if (isGuest() && !location.pathname.startsWith("/s/")) return <><OfflineBanner /><GuestApp /></>;
  return (
    <>
    {!["/login", "/reset-password", "/verify-email"].includes(location.pathname) && <OfflineBanner />}
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/s/:token" element={<PublicAlbumPage />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<AlbumsPage />} />
        <Route path="/library" element={<AdminOnly><LibraryPage /></AdminOnly>} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/albums" element={<AlbumsPage />} />
        <Route path="/albums/:id" element={<AlbumPage />} />
        <Route path="/duplicates" element={<AdminOnly><DuplicatesPage /></AdminOnly>} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SpaceProvider>
          <TakeoutProvider>
            <AppRouter />
            <Toaster position="bottom-center" />
          </TakeoutProvider>
        </SpaceProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
